'use client';

import React, { useEffect, useMemo, useState } from 'react';
import BlogCard from './BlogCard';
import BlogSidebar from '@/features/blog/blog-sidebar/components/BlogSidebar';
import Link from 'next/link';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { useSearchParams } from 'next/navigation';
import BlogCardSkeleton from './BlogCardSkeleton';
import { FaFilter } from 'react-icons/fa'; // Import filter icon

const BlogLeft = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const searchParams = useSearchParams();
  const tagParam = searchParams.get('tags');
  const categoryParam = searchParams.get('category');

  const [visibleCount, setVisibleCount] = useState(6);
  // Reset visibleCount when category or tag changes
  useEffect(() => {
    setVisibleCount(6);
  }, [categoryParam, tagParam]);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992); // MD breakpoint
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  // Dynamically build the query string
  const queryParams = new URLSearchParams();
  if (categoryParam) queryParams.set('category', categoryParam);
  if (tagParam) queryParams.set('tags', tagParam);

  const { data: blogs, isLoading } = useFetcherCSR(
    `/api/v2/blogs?${queryParams.toString()}`
  );

  const allPosts = blogs?.data?.posts || [];

  const visiblePosts = useMemo(() => {
    return allPosts.slice(0, visibleCount);
  }, [allPosts, visibleCount]);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <>
      {/* ================> Page header start here <================== */}
      <section className="page-header section-bg">
        <div className="container ">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Blogs
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      {/* ================> Page header end here <================== */}

      {/* ===============>> Blogs section start here <<================= */}
      <div className="blog padding-bottom section-bg">
        <div className="container position-relative">
          {isMobile && !sidebarOpen && (
            <button
              className="floating-filter-btn d-lg-none"
              onClick={() => setSidebarOpen(true)}
            >
              <FaFilter />
            </button>
          )}
          <div className="blog__wrapper">
            <div className="row g-4">
              {/* <BlogSidebar recentPosts={blogs?.data?.recentPosts || []} /> */}
              <div
                className={`col-lg-4 col-md-8 col-12 sidebar-col p-0 ${sidebarOpen ? 'sidebar-mobile-open' : ''}`}
              >
                <BlogSidebar
                  recentPosts={blogs?.data?.recentPosts || []}
                  onClose={() => setSidebarOpen(false)}
                  isMobileOpen={sidebarOpen}
                />
              </div>
              <div
                className={`sidebar-backdrop d-lg-none m-0 ${sidebarOpen ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              />
              <div className="col-lg-8">
                {isLoading ? (
                  <div className="row g-4">
                    {Array.from({ length: 6 }).map((_, index) => (
                      <BlogCardSkeleton className={'col-sm-6'} key={index} />
                    ))}
                  </div>
                ) : (
                  <div className="row g-4">
                    {visiblePosts?.length > 0 ? (
                      visiblePosts?.map((post: any, index: number) => (
                        <BlogCard
                          key={post.id || index}
                          item={post}
                          className={'col-sm-6'}
                        />
                      ))
                    ) : (
                      <div className="col-12">
                        <p>No blog posts available.</p>
                      </div>
                    )}
                  </div>
                )}

                {!isLoading && visibleCount < allPosts.length && (
                  <div className="blog-btn mt-5 text-center">
                    <button
                      onClick={handleLoadMore}
                      className="trk-btn trk-btn--primary"
                    >
                      View More
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===============>> Blogs section start here <<================= */}
    </>
  );
};

export default BlogLeft;
